// ============================================================
// CANVAS & LAYOUT
// ============================================================

import { BATTLE_COLS, BATTLE_ROWS, M3_COLS, M3_ROWS } from './constants.ts';

export const canvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
export const ctx = canvas.getContext('2d')!;

/** Layout values — recalculated on resize */
export let W = 0;
export let H = 0;
export let CB = 0;   // battle cell size
export let CM = 0;   // match-3 cell size
export let ZBY = 0;  // battle zone Y
export let ZHY = 0;  // HUD zone Y
export let ZMY = 0;  // match-3 zone Y
export let OXB = 0;  // battle grid offset X
export let OYB = 0;  // battle grid offset Y
export let OXM = 0;  // match-3 grid offset X
export let OYM = 0;  // match-3 grid offset Y

export function resize(): void {
  const dpr = window.devicePixelRatio || 1;
  W = Math.max(200, Math.min(window.innerWidth, 500));
  H = Math.max(400, window.innerHeight);
  canvas.width = W * dpr;
  canvas.height = H * dpr;
  canvas.style.width = W + 'px';
  canvas.style.height = H + 'px';
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  const bH = H * 0.47;
  const hH = H * 0.09;
  ZBY = 0;
  ZHY = bH;
  ZMY = bH + hH;
  CB = Math.max(4, Math.floor(Math.min((bH - 24) / BATTLE_ROWS, (W - 16) / BATTLE_COLS)));
  CM = Math.max(4, Math.floor(Math.min((H - ZMY - 38) / (M3_ROWS + 0.5), (W - 16) / M3_COLS)));
  OXB = Math.floor((W - CB * BATTLE_COLS) / 2);
  OYB = ZBY + 22;
  OXM = Math.floor((W - CM * M3_COLS) / 2);
  OYM = ZMY + 28; // Session 6c follow-up: leave room for tab strip (22px + 6 padding)
}

// Initial resize + listen
resize();
window.addEventListener('resize', resize);
